const LogOutfunction = () => {
    localStorage.removeItem("UserDetail");
    localStorage.removeItem("token");
    localStorage.removeItem("successfullyLogin");
    localStorage.removeItem("completeLoginFlow");
  };
  
  
  export default LogOutfunction;
  